export default {
    data() {
        return {
            fields: [],
            sections: [],
            form_category: '',
        }
    },
    mounted() {
        this.$nextTick(() => {
            const fieldDefs = this.$refs.field_defs;
            const loaderContainer = document.createElement('div');
            loaderContainer.id = 'dynamic-form-loader'
            loaderContainer.classList.add('loader-container', 'text-center');
            loaderContainer.innerHTML = '<i class="fa fa-spinner fa-spin fa-9x"></i>';
            fieldDefs.parentNode.insertBefore(loaderContainer, fieldDefs);
        })
    },
    methods: {
        setDateForce(k, v){
          const dtv_ = this.momentMixin(v, 'YYYY-MM-DD')
          this.post.update({
            ...this.post,
            [k]: dtv_
          })
          this.$forceUpdate()
        },
        getCustomFields(url) {
            axios.get(url)
                .then(({data}) => {
                    this.fields = data;
                    (data.custom_fields).map((e) => {
                        let obj = {}
                        if (e.field_type === 'multiple_option') {
                            obj[e.field_key] = [];
                        } else {
                            obj[e.field_key] = null
                        }

                        this.post.update({
                            ...this.post,
                            ...obj
                        })
                    })
                    //work on rendering
                    this.fetchRenderFields()
                })
                .catch(err => console.error(err))
        },
        fetchRenderFields() {
            axios.get(this.genUrl('form_settings', null, 'get_sectioned_field_set'))
                .then(({data}) => {
                    this.sections = data[this.form_category].sections;

                    this.$nextTick(() => {
                        let rendered_fields = []
                        this.sections.forEach(section => {
                            section.directions.forEach((dir, dirIndex) => {
                                section.fields[dirIndex].forEach(field => {
                                    // const orig_node = document.getElementById(`field_${field.field}`)
                                    // const target_node = document.getElementById(`rend_field_${field.field}`)
                                    const orig_f = `field_${field.field}`
                                    const tg_f = `rend_field_${field.field}`
                                    //custom fields are in v-for, those are in array
                                    const orig_node = Array.isArray(this.$refs[orig_f]) ? this.$refs[orig_f][0] : this.$refs[orig_f]
                                    const target_node = this.$refs[tg_f] ? this.$refs[tg_f][0] : null
                                    console.warn([orig_f, tg_f], orig_node, target_node)
                                    //not common node
                                    if (orig_node && !target_node) {
                                        orig_node.remove()
                                    }
                                    //move input
                                    if (orig_node && target_node) {
                                        // console.log(orig_node, target_node)
                                        target_node.appendChild(orig_node)

                                        const firstLabel = target_node.querySelector('label');
                                        if(field.form_view_mandatory){
                                            firstLabel.classList.add('required_star');
                                        }

                                        rendered_fields.push(field)
                                    }
                                })
                            })
                        })
                        // let pop_fields = []
                        //remove unused initial fields
                        const removedFields = []
                        Object.keys(this.post.data()).forEach(od => {
                            const pData = this.post[od]
                            // TODO: more typechecks
                            if (_.isPlainObject(pData)) {
                                //remove nested fields
                                Object.keys(pData).forEach(odn => {
                                    const is_rendered = rendered_fields.find(f_ => {
                                        const fname = f_.level_field ? f_.level_field : f_.field
                                        return f_.level == od && fname == odn
                                    })
                                    if (!is_rendered) {
                                        //TODO: assumption based. use better method
                                        // create manual maps for fields like, 
                                        // relationships<>users
                                        let extra_list = ['experience','phone_json','email_json','linkedin_url']
                                        
                                        if(!extra_list.includes(odn)){
                                            removedFields.push({ type: 'block_remove', level: od, field: odn })
                                            this.$delete(this.post[od], odn)
                                        }
                                        
                                    }
                                })
                            } else {
                                //remove simple fields
                                const is_rendered = rendered_fields.find(f_ => f_.field == od)
                                if (!is_rendered) {
                                    removedFields.push({ type: 'field_remove', field: od })
                                    this.$delete(this.post, od)
                                }
                            }
                        })
                        if (removedFields.length) {
                            console.log('removed_fields', removedFields)
                        }

                        this.postRenderFields()
                    })

                    document.getElementById('dynamic-form-loader').remove()
                })            
        },
        postRenderFields(){
            // override to populate existing data
        },
    }
}